/**
 * Må holdet bookes som gæst (uden konto) i embed-widgetten? Spejler
 * apps/holdstyring/src/lib/bookings/free-class.ts → gaestekoebSpaerring (serverens regel,
 * den eneste håndhævelse der tæller). Widget-pakken kan ikke importere app-koden, så reglen
 * står her igen; paritetstesten (gaeste-booking-gratis-hold.test.ts) holder dem ens.
 *
 *  - Et udtrykkeligt «Gratis hold» (isFree): kun når studiet har slået gæstebooking af gratis
 *    hold til (OPG-0097, V510).
 *  - Ellers: ikke et medlemshold, en pris > 0 og gæste-køb slået til (V355).
 *  - ⛔ 0 kr uden isFree er aldrig en gæste-vej (0 kr betyder ofte «kun med klippekort»).
 * Fuldt hold afgøres af kalderen (venteliste kræver konto).
 */
export interface GuestClass {
  isFree?: boolean
  membershipRequired?: boolean
  dropInPriceDkk?: number | null
}

export interface GuestFeatures {
  guestCheckoutEnabled?: boolean
  guestCheckoutFreeClasses?: boolean
}

export function guestCheckoutAllowed(klass: GuestClass, features: GuestFeatures | undefined): boolean {
  if (klass.isFree === true) return features?.guestCheckoutFreeClasses === true
  if (klass.membershipRequired) return false
  if (!(klass.dropInPriceDkk != null && klass.dropInPriceDkk > 0)) return false
  return features?.guestCheckoutEnabled === true
}
